// Real recent alumni-corner events, sourced from bietdvg.edu/alumini/alumni_association
// (fetched 2026-08-02). Dates as published on the source (day/month only, no year given).
import type { Media } from "@zivin-labs/site-content";

export interface AlumniEvent {
  date: string;
  title: string;
  time?: string;
  location: string;
}

export const ALUMNI_EVENTS: AlumniEvent[] = [
  { date: "Dec 24", title: "Savinenapu Mega Alumni Meet-2022", time: "10:30 AM", location: "BIET" },
  { date: "Oct 10", title: "“Ratrouvaille”", time: "11:00 AM", location: "Textile Dept" },
  { date: "Oct 10", title: "Alumni Meet — Information Science", time: "11:00 AM", location: "ISE Dept" },
  { date: "Sep 20", title: "“Tex-Milana”", time: "11:00 AM", location: "Textile Dept" },
  { date: "Aug 15", title: "“EC-Milana”", time: "10:30 AM", location: "EC Dept" },
  { date: "Jul 29", title: "“Guruvandana” & “Sneha Sammilana”", time: "8:00 PM", location: "CSE Dept" },
  { date: "Jul 25", title: "BT Department Alumni Meet", time: "12:00 PM", location: "BT Dept" },
  { date: "Jul 17", title: "“Guruvandana” & “Sneha Sammilana”", time: "8:00 PM", location: "CSE Dept" },
];

export const ALUMNI_REGISTRATION_URL = "https://www.fresherprofiles.com/alumni/register_contactus";

export const ALUMNI_GUEST_HOUSE = {
  intro:
    "A dedicated guest house for visiting alumni, with a dining hall and guest rooms, on the BIET campus.",
  /**
   * Wide exterior shot — at 2560x1718 the highest-resolution asset in the alumni set, and the
   * only landscape one, so it doubles as the page hero. The portraits are small headshots
   * (some as little as 124x174) and would break up if stretched across a hero.
   */
  hero: {
    url: "sites/biet/alumni/guest-house/exterior.jpg",
    alt: "The BIET Alumni Guest House",
    width: 2560,
    height: 1718,
  } as Media,
  photos: [
    { url: "sites/biet/alumni/guest-house/dining-hall.jpg", alt: "Alumni Guest House dining hall", width: 2048, height: 1360 },
    { url: "sites/biet/alumni/guest-house/guest-room.jpg", alt: "Alumni Guest House guest room", width: 2048, height: 1360 },
  ] as Media[],
};
